import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { DeleteButton, EditLink } from "../_components/AdminRowActions";

const PACKAGE_TYPES = {
  fromAirport: { tone: "info", label: "From Airport" },
  toAirport: { tone: "purple", label: "To Airport" },
  basic: { tone: "gold", label: "Basic" },
};

const NewPackageItem = ({
  package: { _id, packagename, description, type, isactive },
  count,
  deletePackage,
}) => {
  const typeMeta = PACKAGE_TYPES[type];

  return (
    <tr>
      <td className={cellClass}>{count + 1}</td>
      <td className={cellClass}>{packagename}</td>
      <td className={cellClass}>{description}</td>
      <td className={cellClass}>
        {typeMeta ? <AdminBadge tone={typeMeta.tone}>{typeMeta.label}</AdminBadge> : "-"}
      </td>
      <td className={cellClass}>
        <AdminBadge tone={isactive ? "success" : "neutral"}>{isactive ? "Active" : "Inactive"}</AdminBadge>
      </td>
      <td className={stickyCellClass}>
        <AdminRowActions>
          <EditLink to={`/admin/newpackagelist/edit/${_id}`} label="Edit package" />
          <DeleteButton
            label="Delete package"
            onClick={() => deletePackage(_id)}
          />
        </AdminRowActions>
      </td>
    </tr>
  );
};

export default NewPackageItem;
